
import { LABEL_PROVIDER } from '@/constants/labelProvider'

export const getLabelProvider = (labelContent) => {
    if (labelContent.includes('/recepcion-de-paquetes/')) {
        return LABEL_PROVIDER.INTERNAL
    }

    try {
        const labelJson = JSON.parse(labelContent)
        if (Object.hasOwn(labelJson, 'security_digit') && Object.hasOwn(labelJson, 'hash_code')) {
            return LABEL_PROVIDER.MERCADO_ENVIOS_FLEX
        }
    } catch (error) {
        console.error('Error parsing label content:', error)
    }

    return null
}

export const getLabelCodeFromInternal = (labelContent) => {
    return labelContent.split('/recepcion-de-paquetes/')[1]
}

export const getLabelCodeFromMercadoEnviosFlex = (labelContent) => {
    const labelJson = JSON.parse(labelContent)
    return labelJson.id
}

export const getLabelCode = (labelContent) => {
    const labelProvider = getLabelProvider(labelContent)
    switch (labelProvider) {
        case LABEL_PROVIDER.INTERNAL:
            return getLabelCodeFromInternal(labelContent)
        case LABEL_PROVIDER.MERCADO_ENVIOS_FLEX:
            return getLabelCodeFromMercadoEnviosFlex(labelContent)
        default:
            return labelContent
    }
}